import React from 'react';
import { connect } from 'react-redux';
import { selectHasSingleNonPinnedVariable } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { SvgInputControlWindow } from './SvgInputControlWindow';
import { SvgInputOptionGrid } from './SvgInputOptionGrid';

const _SvgInputControlMobile = ({ hasSingleNonPinnedVariable, ...props }: Props) => {
    if (hasSingleNonPinnedVariable) {
        return <SvgInputOptionGrid {...props} />;
    } else {
        return <SvgInputControlWindow {...props} />;
    }
};

type Props = {
    name: string;
    variableIds: string[];
    selectedAssetUrl: string;
    openByDefault: boolean;
    hasSingleNonPinnedVariable: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    hasSingleNonPinnedVariable: selectHasSingleNonPinnedVariable(state)
});

export const SvgInputControlMobile = connect(
    mapStateToProps
)(_SvgInputControlMobile);